import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="py-20 bg-stone-50">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl font-bold mb-8 text-stone-900" style={{ fontFamily: '"Playfair Display", serif' }}>
            Privacy Policy
          </h1>
          
          <div className="bg-white rounded-lg shadow-sm p-8 space-y-6 text-stone-700">
            <p className="text-sm text-stone-500">Last Updated: December 2024</p>
            
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">1. Information We Collect</h2>
              <p className="mb-3">
                At Roaffees, we collect information that you provide directly to us when you:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Visit our café or website</li>
                <li>Make a purchase or place an order</li>
                <li>Subscribe to our newsletter</li>
                <li>Contact us for customer service</li>
                <li>Participate in our events or promotions</li>
              </ul>
              <p className="mt-3">
                This may include your name, email address, phone number, delivery address, and payment information.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">2. How We Use Your Information</h2>
              <p className="mb-3">We use the information we collect to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Process and fulfill your orders</li>
                <li>Send you updates about your orders and deliveries</li>
                <li>Respond to your questions and provide customer support</li>
                <li>Send you promotional emails about new products, special offers, and events (with your consent)</li>
                <li>Improve our products, services, and customer experience</li>
                <li>Prevent fraud and enhance security</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">3. Information Sharing</h2>
              <p className="mb-3">
                We do not sell, trade, or rent your personal information to third parties. We may share your information with:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Service providers who help us operate our business (payment processors, delivery services)</li>
                <li>Legal authorities when required by law or to protect our rights</li>
                <li>Business partners for joint promotions (only with your explicit consent)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">4. Cookies and Tracking</h2>
              <p>
                Our website uses cookies to enhance your browsing experience, analyze site traffic, and personalize content. 
                You can control cookie preferences through your browser settings. Some features may not function properly if cookies are disabled.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">5. Data Security</h2>
              <p>
                We implement appropriate technical and organizational measures to protect your personal information against 
                unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet 
                is 100% secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">6. Your Rights</h2>
              <p className="mb-3">You have the right to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your personal information</li>
                <li>Opt-out of marketing communications at any time</li>
                <li>Withdraw consent for data processing</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">7. Children's Privacy</h2>
              <p>
                Our services are not directed to children under 13 years of age. We do not knowingly collect personal 
                information from children under 13. If you believe we have collected information from a child under 13, 
                please contact us immediately.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">8. Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new 
                Privacy Policy on this page and updating the "Last Updated" date. We encourage you to review this policy 
                periodically.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">9. Contact Us</h2>
              <p className="mb-3">
                If you have any questions about this Privacy Policy or our data practices, please contact us:
              </p>
              <div className="bg-stone-50 p-4 rounded-lg">
                <p className="font-semibold text-stone-900">Roaffees</p>
                <p>Connaught Place, New Delhi, India</p>
                <p>Email: privacy@roaffees.com</p>
                <p>Phone: +91 11 1234 5678</p>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
